import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMediaMobile } from '@app/react/common/useMedia';
import { useHistoryGoParts } from '@app/react/contexts/useHistoryGoParts';
import { showConfirm3DAction } from '@app/react/action';
import type { PartsProduct } from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';
import { ROUTE_PARTS } from '@app/react/const/variables';

type TransitionName = typeof ROUTE_PARTS[number];

export const useHandleClick = (toTransition: TransitionName): (() => void) => {
    const dispatch = useDispatch();
    const isMobile = useMediaMobile();
    const goParts = useHistoryGoParts();

    const shaft = useSelector<AppState, PartsProduct | null>((state) => state.customize.shaft);

    const cb = useCallback(() => {
        if (isMobile) {
            dispatch(showConfirm3DAction({ visible: false }));
        }

        if (shaft === null) {
            goParts('shaft');
            return;
        }

        goParts(toTransition);
    }, [dispatch, goParts, isMobile, shaft, toTransition]);

    return cb;
};
